module.exports = __webpack_public_path__ + "img/banner.b4a5f6d0.png";